import React from 'react';

const HeroSection = () => {
  return (
    <section className="section active">
      <div className="full-bg" style={{backgroundColor: 'var(--bg)', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
        {/* Illustration Line Art en SVG */}
        <svg viewBox="0 0 200 200" width="400" height="400" fill="none" xmlns="http://www.w3.org/2000/svg" style={{opacity: '0.6'}}>
          <path d="M100 160C115 160 130 150 130 120C130 90 110 85 110 60V40" stroke="var(--accent)" strokeWidth="1.5" strokeLinecap="round"/>
          <path d="M100 160C85 160 70 150 70 120C70 90 90 85 90 60V40" stroke="var(--accent)" strokeWidth="1.5" strokeLinecap="round"/>
          {/* Fleur minimaliste */}
          <circle cx="100" cy="35" r="5" stroke="var(--accent)" strokeWidth="1"/>
          <path d="M100 30C105 20 115 25 105 35" stroke="var(--accent)" strokeWidth="1"/>
          <path d="M100 30C95 20 85 25 95 35" stroke="var(--accent)" strokeWidth="1"/>
          <path d="M100 160H110M90 160H100" stroke="var(--accent)" strokeWidth="2" strokeLinecap="round"/>
        </svg>
      </div>
      <div className="container" style={{textAlign: 'center'}}>
        <span className="tagline">Fabria Artisanat</span>
        <h1 style={{color: 'var(--text)'}}>Sublimer le Quotidien</h1>
        <p style={{letterSpacing: '2px', fontWeight: '200', color: 'var(--accent)'}}>
          AUTHENTICITÉ • SIMPLICITÉ • UNICITÉ
        </p>
      </div>
    </section>
  );
};

export default HeroSection;
